// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { saveBlobResponse } from '@/file/utilities/save-blob-response';

/**
 * Downloads a file by its key by fetching it through the API as a blob and
 * triggering a browser download, so the file saves directly instead of opening
 * in a new tab. Falls back to the file key as the filename when the response
 * carries no Content-Disposition.
 */
export async function downloadFileByKey(fileKey: string): Promise<void> {
  const response = await api.get(`/v1/file/${fileKey}`, {
    responseType: 'blob',
  });

  saveBlobResponse(
    response.data,
    response.headers['content-disposition'],
    fileKey
  );
}
